import { Form } from "antd";
import { useEffect, useState } from "react";
import { useMercuryContext } from "../../context";
import {
  successfulNotification,
  failedNotification,
} from "../../common/utils/notifications";
import CurrenciesRequestForm from "./CurrenciesRequestForm";

interface ManageCurrenciesProps {
  initialValues?: Record<string, any>;
  buttonLabel: string;
  refresh: () => void;
  selectedRows?: number[];
  hasPermissions: boolean;
}

const ManageCurrencies: React.FC<ManageCurrenciesProps> = ({
  initialValues,
  buttonLabel,
  refresh,
  selectedRows,
  hasPermissions,
}) => {
  const [form] = Form.useForm();
  const { gpClient } = useMercuryContext();
  const [isOpen, setIsOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [currentId, setCurrentId] = useState("");

  const openDrawer = (initialValues?: any) => {
    setIsOpen(true);
  };

  useEffect(() => {
    if (isOpen && initialValues) {
      setCurrentId(initialValues?.id);
      form.setFieldsValue(initialValues);
    }
  }, [isOpen, initialValues,form]);

  const closeDrawer = () => {
    setIsOpen(false);
    form.resetFields();
  };

  const submitCurrencies = async (values: any) => {
    setSubmitting(true);
    try {
      if (!currentId) {
        await gpClient.post("/core-v1/currency", values);
      } else {
        await gpClient.patch(`/core-v1/currency/${currentId}`, values);
      }

      closeDrawer();
      successfulNotification(
        `Currency is ${currentId ? "updated" : "added"}`,
        "Please refresh your page if the update is not visible."
      );
      refresh();
    } catch (error) {
      failedNotification("Error updating Currencies", error?.toString());
    } finally {
      setSubmitting(false);
    }
  };

  return (
      <CurrenciesRequestForm
        buttonLabel={buttonLabel}
        form={form}
        isOpen={isOpen}
        openDrawer={openDrawer}
        closeDrawer={closeDrawer}
        type={currentId ? "Edit" : "Add"}
        onSubmit={(values) => submitCurrencies(values)}
        submitting={submitting}
        selectedRows={selectedRows}
        hasPermissions={hasPermissions}
      />
  );
};

export default ManageCurrencies;
